import { render, staticRenderFns } from "./Arbo.vue?vue&type=template&id=ec078f42&scoped=true&"
import script from "./Arbo.vue?vue&type=script&lang=js&"
export * from "./Arbo.vue?vue&type=script&lang=js&"
import style0 from "./Arbo.vue?vue&type=style&index=0&id=ec078f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec078f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec078f42')) {
      api.createRecord('ec078f42', component.options)
    } else {
      api.reload('ec078f42', component.options)
    }
    module.hot.accept("./Arbo.vue?vue&type=template&id=ec078f42&scoped=true&", function () {
      api.rerender('ec078f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/Arbo.vue"
export default component.exports